"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCXAppdxItem = exports.HTMLAppdxItem = exports.HTMLAppdxItemCSS = void 0;
const react_1 = __importDefault(require("react"));
const std = __importStar(require("../../law/std"));
const util_1 = require("../../util");
const html_1 = require("../common/html");
const sentenceChildrenRun_1 = require("./sentenceChildrenRun");
const component_1 = require("../common/docx/component");
const tags_1 = require("../common/docx/tags");
const itemStruct_1 = require("./itemStruct");
const paragraphItem_1 = require("./paragraphItem");
const remarks_1 = require("./remarks");
const arithFormulaRun_1 = require("./arithFormulaRun");
const common_1 = require("../common");
exports.HTMLAppdxItemCSS = `
.appdx-item {
    clear: both;
}

.appdx-item-head {
    clear: both;
    font-weight: bold;
}

`;
exports.HTMLAppdxItem = (0, html_1.wrapHTMLComponent)("HTMLAppdxItem", ((props) => {
    const { el, htmlOptions, indent } = props;
    const blocks = [];
    const AppdxItemTitle = el.children.find(el => (std.isAppdxItemTitle(el)
        || std.isSupplProvisionAppdxItemTitle(el)));
    const RelatedArticleNum = el.children.find(std.isRelatedArticleNum);
    if (AppdxItemTitle || RelatedArticleNum) {
        blocks.push((react_1.default.createElement("div", { className: `appdx-item-head indent-${indent}` },
            (AppdxItemTitle !== undefined) && (react_1.default.createElement("span", { className: "appdx-item-title", ...(0, html_1.elProps)(AppdxItemTitle, htmlOptions) },
                react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: AppdxItemTitle.children, htmlOptions }))),
            (RelatedArticleNum !== undefined) && (react_1.default.createElement("span", { className: "related-article-num", ...(0, html_1.elProps)(RelatedArticleNum, htmlOptions) },
                react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: RelatedArticleNum.children, htmlOptions }))))));
    }
    const bodyBlocks = [];
    for (const child of el.children) {
        if (std.isAppdxItemTitle(child)
            || std.isSupplProvisionAppdxItemTitle(child)
            || std.isRelatedArticleNum(child)) {
            continue;
        }
        else if (std.isRemarks(child)) {
            bodyBlocks.push(react_1.default.createElement(remarks_1.HTMLRemarks, { el: child, indent: indent, htmlOptions }));
        }
        else if (std.isTableStruct(child) || std.isFigStruct(child) || std.isNoteLikeStruct(child)) {
            bodyBlocks.push(react_1.default.createElement(itemStruct_1.HTMLItemStruct, { el: child, indent: indent, htmlOptions }));
        }
        else if (std.isItem(child)) {
            bodyBlocks.push(react_1.default.createElement(paragraphItem_1.HTMLParagraphItem, { el: child, indent: indent, htmlOptions }));
        }
        else if (std.isArithFormula(child)) {
            bodyBlocks.push((react_1.default.createElement("div", { className: `appdx-item-runs indent-${indent}`, ...(0, html_1.elProps)(child, htmlOptions) },
                react_1.default.createElement(arithFormulaRun_1.HTMLArithFormulaRun, { el: child, htmlOptions }))));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    if (bodyBlocks.length > 0) {
        blocks.push((react_1.default.createElement("div", { className: "appdx-item-body" }, (0, common_1.withKey)(bodyBlocks))));
    }
    return (react_1.default.createElement("div", { className: "appdx-item", ...(0, html_1.elProps)(el, htmlOptions) }, (0, common_1.withKey)(blocks)));
}));
exports.DOCXAppdxItem = (0, component_1.wrapDOCXComponent)("DOCXAppdxItem", ((props) => {
    const { el, docxOptions, indent } = props;
    const blocks = [];
    const AppdxItemTitle = el.children.find(el => (std.isAppdxItemTitle(el)
        || std.isSupplProvisionAppdxItemTitle(el)));
    const RelatedArticleNum = el.children.find(std.isRelatedArticleNum);
    const hasFig = Boolean(el.children.find((c => (std.isTableStruct(c) || std.isFigStruct(c) || std.isNoteLikeStruct(c))
        && c.children.length !== 0
        && (std.isFig(c.children[0])
            || (std.isNoteLike(c.children[0])
                && c.children[0].children.length !== 0
                && std.isFig(c.children[0].children[0]))))));
    if (AppdxItemTitle || RelatedArticleNum) {
        blocks.push((react_1.default.createElement(tags_1.w.p, null,
            react_1.default.createElement(tags_1.w.pPr, null,
                react_1.default.createElement(tags_1.w.pStyle, { "w:val": `Indent${indent}` }),
                hasFig && react_1.default.createElement(tags_1.w.keepNext, null),
                hasFig && react_1.default.createElement(tags_1.w.keepLines, null)),
            (AppdxItemTitle !== undefined) && (react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: AppdxItemTitle.children, emphasis: true, docxOptions })),
            (RelatedArticleNum !== undefined) && (react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: RelatedArticleNum.children, emphasis: true, docxOptions })))));
    }
    for (const child of el.children) {
        if (std.isAppdxItemTitle(child)
            || std.isSupplProvisionAppdxItemTitle(child)
            || std.isRelatedArticleNum(child)) {
            continue;
        }
        else if (std.isRemarks(child)) {
            blocks.push(react_1.default.createElement(remarks_1.DOCXRemarks, { el: child, indent: indent, docxOptions }));
        }
        else if (std.isTableStruct(child) || std.isFigStruct(child) || std.isNoteLikeStruct(child)) {
            blocks.push(react_1.default.createElement(itemStruct_1.DOCXItemStruct, { el: child, indent: indent, docxOptions }));
        }
        else if (std.isItem(child)) {
            blocks.push(react_1.default.createElement(paragraphItem_1.DOCXParagraphItem, { el: child, indent: indent, docxOptions }));
        }
        else if (std.isArithFormula(child)) {
            blocks.push((react_1.default.createElement(tags_1.w.p, null,
                react_1.default.createElement(tags_1.w.pPr, null,
                    react_1.default.createElement(tags_1.w.pStyle, { "w:val": `Indent${indent}` })),
                react_1.default.createElement(arithFormulaRun_1.DOCXArithFormulaRun, { el: child, docxOptions }))));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(blocks)));
}));
//# sourceMappingURL=appdxItem.js.map